"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const device_1 = require("./device");
const jsonparser_1 = require("../requests/jsonparser");
var Permission;
(function (Permission) {
    Permission["USER"] = "user";
    Permission["ALBUM"] = "album";
    Permission["RADIOCHART"] = "radiochart";
    Permission["CURATED"] = "curated";
    Permission["PODCAST"] = "podcast";
    Permission["PLAYLIST"] = "playlist";
    Permission["REPORTING"] = "reporting";
    Permission["ARTIST"] = "artist";
    Permission["ADMINISTRATOR"] = "administrator";
    Permission["COUPON"] = "coupon";
    Permission["GENRE"] = "genre";
    Permission["CATEGORY"] = "category";
    Permission["TAG"] = "tag";
    Permission["LIVE"] = "live";
    Permission["BANNER"] = "banner";
})(Permission = exports.Permission || (exports.Permission = {}));
var SpecialPermission;
(function (SpecialPermission) {
    SpecialPermission["QC"] = "qc";
})(SpecialPermission = exports.SpecialPermission || (exports.SpecialPermission = {}));
class User {
}
__decorate([
    jsonparser_1.JsonProperty({ type: 'false' }),
    __metadata("design:type", String)
], User.prototype, "ISHELPERMODEL", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'User' }),
    __metadata("design:type", String)
], User.prototype, "MODELNAME", void 0);
__decorate([
    jsonparser_1.JsonProperty({ required: true, type: 'number' }),
    __metadata("design:type", Number)
], User.prototype, "id", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], User.prototype, "email", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string' }),
    __metadata("design:type", String)
], User.prototype, "full_name", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string' }),
    __metadata("design:type", String)
], User.prototype, "theme", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], User.prototype, "username", void 0);
__decorate([
    jsonparser_1.JsonProperty({ clazz: device_1.Device, type: 'Device?' }),
    __metadata("design:type", Array)
], User.prototype, "devices", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], User.prototype, "profile_image_url", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], User.prototype, "refresh_token", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], User.prototype, "profile_image_thumbnail_url", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], User.prototype, "profile_image_medium_url", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'boolean?' }),
    __metadata("design:type", Boolean)
], User.prototype, "hq_allowed", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'boolean?' }),
    __metadata("design:type", Boolean)
], User.prototype, "verification_complete", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'boolean?' }),
    __metadata("design:type", Boolean)
], User.prototype, "is_admin", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], User.prototype, "tshirt_size", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], User.prototype, "affiliation", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'any?' }),
    __metadata("design:type", Object)
], User.prototype, "admin_features", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], User.prototype, "dob", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], User.prototype, "dj_type", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string' }),
    __metadata("design:type", String)
], User.prototype, "verification_status", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'boolean?' }),
    __metadata("design:type", Boolean)
], User.prototype, "beta_tester", void 0);
exports.User = User;
